var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { doWhenP } from '../utils';
import { getRequestId, updateRequest } from '../dataLayer';
import { getCacheItem, setCacheItem } from '../cache';
const CACHED_KEY = 'ga_session_data';
export function getSessionData() {
    const data = {
        ga_session_id: null,
        ga_session_number: null,
    };
    const [rawCookie, rawValue] = document.cookie.match(/_ga_[A-Za-z0-9]+=(.*?)(?:;|$)/) || ['', ''];
    const match = rawCookie.match(/_ga_[A-Za-z0-9]+=GS\d\.\d\.(.+?)(?:;|$)/);
    if (match) {
        const parts = match[1].split('.');
        data.ga_session_id = parts.shift() || null;
        data.ga_session_number = parts.shift() || null;
    }
    else if (rawValue.length) {
        data.ga_session_id = rawValue;
        data.ga_session_number = rawValue;
    }
    return data;
}
function handlePredicate() {
    return getRequestId() && Object.values(getSessionData()).every(v => !!v);
}
function sendSessionData() {
    const requestId = getRequestId();
    const sessionData = getSessionData();
    const cachedData = getCacheItem(CACHED_KEY);
    const data = Object.assign(Object.assign({}, sessionData), { request_id: requestId });
    const sameReqId = typeof cachedData === 'object' && cachedData.request_id === requestId;
    const sameGaId = typeof cachedData === 'object' && sessionData.ga_session_id === cachedData.ga_session_id;
    if (sameReqId && sameGaId)
        return;
    updateRequest(requestId, { ga_session_data: data }).then(() => {
        setCacheItem(CACHED_KEY, data);
    });
}
export function run() {
    return __awaiter(this, arguments, void 0, function* (expiration = 10000) {
        return doWhenP(handlePredicate, expiration, false)
            .then(() => sendSessionData())
            .catch(e => {
            console.log('error sending ga session ID: ', e);
        });
    });
}
//# sourceMappingURL=googleSessionId.js.map